import React from 'react';
import { cleanFilter, updateFilter } from '../../redux/actions/filtroAction';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import ambiente from '../../config/ambienteConfig';
import moment from 'moment';


class Filtro extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listaContas: [],
            listaOrdem: [
                { id: 'descricao', nome: 'Descrição' },
                { id: 'envolvido', nome: 'Interessado' },
                { id: 'data_transacao', nome: 'Data da Transação' },
                { id: 'data_pagamento', nome: 'Data do Pagamento' },
                { id: 'valor', nome: 'Valor' },
            ]
        };
    }

    componentDidMount = async () => {
        const resContas = await axios.get(`${ambiente.dev.server}/contas`);
        this.setState({ listaContas: resContas.data });
    }

    handleAtualizarDataFiltro = async (dataTexto) => {
        const data = moment(dataTexto.target.value, 'YYYY-MM');
        await this.props.updateFilter({ data });
        this.props.atualizar();
    }

    handleAlterarContaFiltro = async (evt) => {
        await this.props.updateFilter({ conta: evt.target.value });
        this.props.atualizar();
    }

    handleAlterarTipoFiltro = async (tipo) => {
        await this.props.updateFilter({ tipo });
        this.props.atualizar();
    }

    handleAlterarStatusFiltro = async (status) => {
        await this.props.updateFilter({ status });
        this.props.atualizar();
    }

    handleAlterarRegimeMensalFiltro = async () => {
        await this.props.updateFilter({ filtroMensal: !this.props.filtro.filtroMensal });
        this.props.atualizar();
    }

    handleAlterarConsiderarPendentesFiltro = async () => {
        await this.props.updateFilter({ considerarPendentes: !this.props.filtro.considerarPendentes });
        this.props.atualizar();
    }

    handleAlterarOrdenacaoFiltro = async (evt) => {
        await this.props.updateFilter({ orderBy: evt.target.value });
        this.props.atualizar();
    }

    handleReset = async () => {
        await this.props.cleanFilter();
        this.props.atualizar();
    }

    render() {

        return (
            <div className="row">
                {this.props.data &&
                    <div className="form-group col-2">
                        <input type="month" className="form-control" value={this.props.filtro.data.format('YYYY-MM')}
                            autoFocus onChange={this.handleAtualizarDataFiltro} title="Filtro de Período" />
                    </div>
                }
                {this.props.conta &&
                    <div className="form-group col-2">
                        <select className="form-control" value={this.props.filtro.conta} onChange={this.handleAlterarContaFiltro} aria-label="Filtro de Conta">
                            <option key={0} value="">Selecione uma conta...</option>
                            {this.state.listaContas.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                }
                {this.props.tipo &&
                    <div className="form-group col-2" data-toggle="buttons">
                        <button type="button" onClick={() => this.handleAlterarTipoFiltro('REC')} alt="Filtrar por contas a receber"
                            className={`btn btn-sm ${this.props.filtro.tipo === 'REC' ? 'btn-success active' : 'btn-outline-secondary'}`}>
                            <i className="fas fa-thumbs-up" title="Filtrar por contas a receber" />
                        </button>
                        <button type="button" onClick={() => this.handleAlterarTipoFiltro('')} style={{ "marginTop": 0 }}  alt="Sem filtro de pagamentos"
                            className={`btn btn-sm ${this.props.filtro.tipo === '' ? 'btn-info active' : 'btn-outline-secondary'}`}>
                            <i className="far fa-hand-peace" title="Sem filtro de pagamentos" />
                        </button>
                        <button type="button" onClick={() => this.handleAlterarTipoFiltro('DESP')} style={{ "marginTop": 0 }}  alt="Filtrar por contas a pagar"
                            className={`btn btn-sm ${this.props.filtro.tipo === 'DESP' ? 'btn-danger active' : 'btn-outline-secondary'}`}>
                            <i className="fas fa-thumbs-down" title="Filtrar por contas a pagar" />
                        </button>
                    </div>
                }
                {this.props.status &&
                    <div className="form-group col-2" data-toggle="buttons">
                        <button type="button" onClick={() => this.handleAlterarStatusFiltro('true')}  alt="Filtrar por contas pagas"
                            className={`btn btn-sm ${this.props.filtro.status === 'true' ? 'btn-success' : 'btn-outline-secondary'}`}>
                            <i className="fas fa-check" title="Filtrar por contas pagas" />
                        </button>
                        <button type="button" onClick={() => this.handleAlterarStatusFiltro('')} style={{ "marginTop": 0 }}  alt="Sem filtro de status"
                            className={`btn btn-sm ${this.props.filtro.status === '' ? 'btn-info' : 'btn-outline-secondary'}`}>
                            <i className="far fa-hand-peace" title="Sem filtro de status"/>
                        </button>
                        <button type="button" onClick={() => this.handleAlterarStatusFiltro('false')} style={{ "marginTop": 0 }}  alt="Filtrar por contas pendentes"
                            className={`btn btn-sm ${this.props.filtro.status === 'false' ? 'btn-danger' : 'btn-outline-secondary'}`}>
                            <i className="fas fa-times" title="Filtrar por contas pendentes" />
                        </button>
                    </div>
                }
                {this.props.ordem &&
                    <div className="form-group col-2">
                        <select className="form-control" value={this.props.filtro.orderBy} onChange={this.handleAlterarOrdenacaoFiltro}  aria-label="Ordenação">
                            {this.state.listaOrdem.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                }
                <div className="form-group col-2" data-toggle="buttons">
                    {this.props.pendentes &&
                        <button type="button" onClick={() => this.handleAlterarConsiderarPendentesFiltro()}
                            className={`btn btn-sm ${this.props.filtro.considerarPendentes ? 'btn-warning' : 'btn-outline-secondary'}`}>
                            <i className="fas fa-globe" />
                        </button>
                    }
                    {this.props.mes &&
                        <button type="button" onClick={() => this.handleAlterarRegimeMensalFiltro()}
                            className={`btn btn-sm ${this.props.filtro.filtroMensal ? 'btn-warning' : 'btn-outline-secondary'}`}>
                            <i className="far fa-calendar-alt" />
                        </button>
                    }
                    <button type="button" onClick={this.handleReset} className={`btn btn-sm btn-outline-dark`}  alt="Resetar filtro">
                        <i className="fas fa-undo" title="Resetar filtro" />
                    </button>
                </div>
            </div>
        );
    }
}

Filtro.propTypes = {
    data: PropTypes.bool,
    conta: PropTypes.bool,
    tipo: PropTypes.bool,
    status: PropTypes.bool,
    pendentes: PropTypes.bool,
    mes: PropTypes.bool,
    ordem: PropTypes.bool,
    updateFilter: PropTypes.func.isRequired,
    cleanFilter: PropTypes.func.isRequired,
    atualizar: PropTypes.func.isRequired,
    filtro: PropTypes.object.isRequired,
};

function mapStateToProps({ filtro }) {
    return {
        filtro: filtro
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateFilter: filtro => dispatch(updateFilter(filtro)),
        cleanFilter: () => dispatch(cleanFilter())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Filtro);


// WEBPACK FOOTER //
// ./src/components/relatorios/Filtro.js